export const READ_FEE_SETUP_COLLECTION = "READ_FEE_SETUP_COLLECTION";
export const CREATE_FEE_SETUP_COLLECTION = "CREATE_FEE_SETUP_COLLECTION";

export const RESET_SETUP_FEE = "RESET_SETUP_FEE";
export const UPDATE_FEE_SETUP_FEE_COLLECTION =
  "UPDATE_FEE_SETUP_FEE_COLLECTION";
export const UPDATE_FEE_SETUP_FEE_COUNTER = "UPDATE_FEE_SETUP_FEE_COUNTER";
